export default {
  lang: {
    confirm: {
      title: '您確認要刪除嗎? 刪除後將不能再恢復',
      okText: '刪除',
      cancelText: '取消',
    },
  },
};
